import { injectLoggerApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/logger.service';
import { baseApi } from '@service/base.api';

export const logApi = injectLoggerApi(baseApi);

export const {
  useGetLogsPaginatedQuery,
  useGetOcpiLogsPaginatedQuery,
  useGetEmspWebAppLogsPaginatedQuery,
} = logApi;
